.ds-button {
  border: none;
  background: transparent;
  outline: none;
  padding: 0;
  margin: 0;

  &:focus {
    outline: none;
  }

  &:not([disabled]) {
    cursor: pointer;
  }

  &:has([slot="before"]),
  &:has([slot="after"]) {
    display: flex;
    align-items: center;
    
    & > :not([slot="before"]):not([slot="after"]) {
      flex-grow: 1;
    }
  }
}
